import { createHook, createStore } from 'react-sweet-state';

import actions from './actions';
import { FIELD_STATE_TIMED_OUT, FIELD_STATE_FAILED } from './constants';
import type { InlineFieldsState } from './types';

type Actions = typeof actions;

const store = createStore<InlineFieldsState, Actions>({
	actions,
	name: 'forge.custom-fields.inline-fields-state',
	initialState: {},
});

export const useInlineField = createHook(store, {
	selector: (state, fieldId: string) => state[fieldId],
});

export const useInlineFields = createHook(store);

export const useFailedOrTimedOutInlineFields = createHook(store, {
	selector: (state) =>
		Object.keys(state).filter(
			(fieldId) =>
				state[fieldId].status === FIELD_STATE_TIMED_OUT ||
				state[fieldId].status === FIELD_STATE_FAILED,
		),
});
